<!--
 * @Author: daidai
 * @Date: 2022-03-01 09:43:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-09 11:40:22
 * @FilePath: \web-pc\src\pages\big-screen\view\indexs\left-bottom.vue
-->
<template>
  <div
    v-if="pageflag"
    class="left_boottom_wrap beautify-scroll-def"
    :class="{ 'overflow-y-auto': !sbtxSwiperFlag }"
  >
    <component :is="components" :data="list" :class-option="classOption" >
      <ul class="left_boottom">
        <li class="left_boottom_item" v-for="(item, i) in list" :key="i">
          <div class="inner_right">
            <div class="dibu"></div>
            <div class="flex">
              <div class="info">
                <span class="labels">  {{ item.deptName }}</span>
              </div>
            </div>
            <div class="info addresswrap">
              <span class="labels"> {{ item.equipmentName }}</span>
                <span
                class="types doudong"
                :class="{
                  typeRed: item.showStatus == 0,
                  typeGreen: item.showStatus == 1,
                }"
                >{{ item.clockInData}}</span
              >
            </div>
            
            
          </div>
        </li>
      </ul>
    </component>
  </div>

  <Reacquire v-else @onclick="getData" style="line-height: 200px" />
</template>

<script>
import { currentGET } from "api";
import vueSeamlessScroll from "vue-seamless-scroll"; // vue2引入方式
import Kong from "../../components/kong.vue";
import { statCurDateEquClockInData } from 'api/modules/largescreen'

export default {
  components: { vueSeamlessScroll, Kong },
  data() {
    return {
      list: [],
      pageflag: true,
      components: vueSeamlessScroll,
      defaultOption: {
        ...this.$store.state.setting.defaultOption,
        singleHeight: 240,
        limitMoveNum: 5, 
        step: 0,
      },
    };
  },
  computed: {
    sbtxSwiperFlag() {
      let sbtxSwiper = this.$store.state.setting.sbtxSwiper;
      if (sbtxSwiper) {
        this.components = vueSeamlessScroll;
      } else {
        this.components = Kong;
      }
      return sbtxSwiper;
    },
     classOption () {//大屏滚动配置参数
      return {
        step: 3, // 数值越大速度滚动越快
        limitMoveNum: 10, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: this.scrollHeigth, //单步运动停止的高度(默认值0是无缝不停止的滚动) 一行的高度
        waitTime: 400 // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  created() {
    
  },

  mounted() {
    this.getData();
  },
  methods: {
    addressHandle(item) {
      let name = item.provinceName;
      if (item.cityName) {
        name += "/" + item.cityName;
        if (item.countyName) {
          name += "/" + item.countyName;
        }
      }
      return name;
    },
    getData() {
      this.pageflag = true;
      // this.pageflag =false
      // currentGET("big3", { limitNum: 20 }).then((res) => {
      //   console.log("设备提醒", res);
      //   if (res.success) {
      //     this.countUserNumData = res.data;
      //     this.list = res.data.list;
      //     let timer = setTimeout(() => {
      //       clearTimeout(timer);
      //       this.defaultOption.step =
      //         this.$store.state.setting.defaultOption.step;
      //     }, this.$store.state.setting.defaultOption.waitTime);
      //   } else {
      //     this.pageflag = false;
      //     this.$Message({
      //       text: res.msg,
      //       type: "warning",
      //     });
      //   }
      // });


      statCurDateEquClockInData().then((res) => {
        console.log("设备打卡情况", res);
        if (res.code == 200) {

          let dpShowAreaId = localStorage.getItem("dpShowAreaId");

          this.countUserNumData = res.data;
          
          this.list = [];
          let resultDataList = res.data.list;
          for (let i = 0; i < resultDataList.length; i++) {
              let clockInAm = resultDataList[i].clockInAm;
              let clockInPm = resultDataList[i].clockInPm;

              // 广元利州区设置默认值 20260521 baoxiaoyu add
              //if(dpShowAreaId == '510802'){
              //    clockInAm = "1";
              //    let currentHour = new Date().getHours();
                  // 判断是否超过13点
             //     if (currentHour >= 13) {
             //         clockInPm = "1";
             //     }
             // }

              var clockInData = '上午未打卡';
              var showStatus = "0";
              if(clockInAm == '1'){
                clockInData = "上午已打卡";
                showStatus = "1";
              }
              resultDataList[i].clockInData = clockInData;
              resultDataList[i].showStatus = showStatus;
              this.list.push(resultDataList[i]);

              const copyData = {...resultDataList[i] };
              if(clockInPm != '2'){
                clockInData = '下午未打卡';
                showStatus = "0";
                if(clockInPm == '1'){
                    clockInData = "下午已打卡";
                    showStatus = "1";
                    
                }
                copyData.clockInData = clockInData;
                copyData.showStatus = showStatus;
                this.list.push(copyData);
              }
          }

          let timer = setTimeout(() => {
            clearTimeout(timer);
              this.getData();
          }, this.$store.state.setting.defaultOption.waitTime);
        } else {
          this.pageflag = false;
          this.$Message({
            text: res.msg,
            type: "warning",
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.left_boottom_wrap {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.doudong {
   vertical-align:middle;
  float: right;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  backface-visibility: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.left_boottom {
  width: 100%;
  height: 100%;

  .left_boottom_item {
    // display: flex;
    display:block;
    align-items: center;
    justify-content: center;
    padding: 8px;
    font-size: 14px;
    margin: 10px 0;
    .orderNum {
      margin: 0 16px 0 -20px;
    }

    .info {
      margin-right: 10px;
      display: flex;
      align-items: center;
      color: #fff;

      .labels {
        float: left;
        flex-shrink: 0;
        font-size: 24px;
        color: rgba(255, 255, 255, 0.6);
      }

      .zhuyao {
        color: $primary-color;
        font-size: 15px;
      }

      .ciyao {
        color: rgba(255, 255, 255, 0.8);
      }

      .warning {
        color: #e6a23c;
        font-size: 15px;
      }
    }

    .inner_right {
      position: relative;
      height: 100%;
      width: 100%;
      flex-shrink: 0;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .dibu {
        position: absolute;
        height: 2px;
        width: 104%;
        background-image: url("../../assets/img/zuo_xuxian.png");
        bottom: -10px;
        left: -2%;
        background-size: cover;
      }
      .addresswrap {
        width: 100%;
        // display: flex;
        display: block;
        margin-top: 8px;
      }
    }

    .wangguan {
      color: #1890ff;
      font-weight: 900;
      font-size: 15px;
      width: 80px;
      flex-shrink: 0;
    }


    .time {
      font-size: 12px;
      // color: rgba(211, 210, 210,.8);
      color: #fff;
    }

    .address {
      font-size: 12px;
      cursor: pointer;
      // @include text-overflow(1);
    }

    .types {
      width: 140px;
      flex-shrink: 0;
      font-size: 24px;
    }

    .typeRed {
      color: #fc1a1a;
    }

    .typeGreen {
      color: #29fc29;
    }
  }
}
</style>